var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.tfaState
        ? _c(
            "md-list-item",
            { on: { click: _vm.recoverFactor } },
            [
              _c("span", { staticClass: "settings__item-text text_large" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_recover_2fa()))
              ]),
              _vm._v(" "),
              _c("md-icon", { staticClass: "md-icon--half-sized" }, [
                _vm._v("keyboard_arrow_right")
              ])
            ],
            1
          )
        : _c(
            "md-list-item",
            { on: { click: _vm.createFactor } },
            [
              _c("span", { staticClass: "settings__item-text text_large" }, [
                _vm._v(_vm._s(_vm.i18n.lbl_add_2fa()))
              ]),
              _vm._v(" "),
              _c("md-icon", { staticClass: "md-icon--half-sized" }, [
                _vm._v("keyboard_arrow_right")
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.isSettingsOpened },
          on: {
            "update:mdActive": function($event) {
              _vm.isSettingsOpened = $event
            },
            "update:md-active": function($event) {
              _vm.isSettingsOpened = $event
            }
          }
        },
        [
          _c("md-dialog-title", [_vm._v(_vm._s(_vm.i18n.set_tfa_enable()))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "app__dialog-inner" },
            [
              _c("p", { staticClass: "tfa-settings__explain" }, [
                _vm._v(_vm._s(_vm.i18n.set_tfa_scan_the_qr_code()))
              ]),
              _vm._v(" "),
              _vm.inputMode === _vm.INPUT_MODES.qr
                ? _c(
                    "div",
                    { staticClass: "tfa-settings__qr-outer" },
                    [
                      _c("qrcode", {
                        staticClass: "tfa-settings__qr-code",
                        attrs: {
                          text: _vm.factor.qr,
                          size: 225,
                          color: "#3f4244"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "tfa-settings__explain-additional" }, [
                _vm._v(_vm._s(_vm.i18n.set_or_manually_enter()))
              ]),
              _vm._v(" "),
              _c("clipboard-field", {
                staticClass: "tfa-settings__copy-secret",
                attrs: {
                  value: _vm.factor.secret,
                  label: _vm.i18n.lbl_secret()
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            { staticClass: "md-layout md-alignment-center-right" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function($event) {
                      _vm.isSettingsOpened = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                { staticClass: "md-primary", on: { click: _vm.updateFactor } },
                [_vm._v(_vm._s(_vm.i18n.lbl_confirm()))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91198992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91198992","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/settings/security/Security.TfaSettings.vue
// module id = pmOi
// module chunks = 1